/*
 * @Author: Trae AI
 * @Date: 2023-10-27 15:30:00
 * @LastEditors: Trae AI
 * @LastEditTime: 2023-10-27 15:30:00
 * @Description: 笔记卡片样式4 - 仿UI高保真还原
 */
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { px2dpSmall } from '../../../../../utils/px2dp';
import utils from '../../../../../utils/utils';
import { getByteCount } from '../../BytesCount';
import Request from '../../../../../utils/request';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';

const praised_icon = 'https://static.shihuocdn.cn/admin/files/20241029/ccb6c6caff2783d6ee264a93e088af3a.png'//选中后
const un_praised_icon = 'https://static.shihuocdn.cn/admin/files/20241029/437472759078c049024b762b9f409aad.png'//未点赞
const praised_animated = 'https://static.shihuocdn.cn/admin/files/20241029/8a40e7c94f8d375a920c52b5f2ab4207.svga'//点赞动效
const cancel_praised_animated = 'https://static.shihuocdn.cn/admin/files/20241029/f83b3847007875c51b0336c78af12616.svga'//取消点赞
const play_icon = 'http://static.shihuocdn.cn/admin/files/20260303/3b730fcf121d4315ea2af6ef84a142f7.png'
const bottom_bg_icon = 'http://static.shihuocdn.cn/admin/files/20230807/03a59277acc673321aeb626eeba330c6.png'
const article_icon = 'http://static.shihuocdn.cn/admin/files/20230807/cdad47a3f86850e6156c087ae7ab7c53.png'
const animated_svga = 'http://static.shihuocdn.cn/app/res/dsgn/ab45f0ee9d5b454badb02fe85a29c256.svga'
const user_level_1 = 'http://static.shihuocdn.cn/admin/files/20220830/1dc074021fc6b5f706de782042fed04e.png'
const user_level_2 = 'http://static.shihuocdn.cn/admin/files/20220830/7f4f3d0a182686e5766946afa122a3f7.png'
const user_level_3 = 'http://static.shihuocdn.cn/admin/files/20220830/0a1a00fa186d88222513a22d12e474bc.png'

const screen = typeof window !== 'undefined' && window.screen;
const isIOS = typeof window !== 'undefined' && /ios|iphone|ipad/i.test(navigator.userAgent);
const vCardWidth = typeof window !== 'undefined' && (window.innerWidth - px2dpSmall(12) * 2 - px2dpSmall(9)) / 2;

const requestNotePraised = async (id, channel_type, isPraise) => {
    let url = 'http://apps.shihuo.cn/app_swoole_common/praise'
    let params = { id, channel_type, status: isPraise ? '1' : '2' }
    return new Promise((resolve, reject) => {
        Request({
            url,
            method: 'get',
            params
        }).then(value => {
            resolve(value)
        }).catch(err => {
            reject(err)
        })
    })
}

function getUserLevelImg(level) {
    switch (level) {
        case 1:
            return user_level_1
        case 2:
            return user_level_2
        case 3:
            return user_level_3
        default:
            return user_level_1
    }
}
function getNoteNumberOfLines(item, widgetWidth) {
    let { name = '' } = item
    let lineWidth = widgetWidth - px2dpSmall(10) * 2
    return getNumberOfLines(name, lineWidth, px2dpSmall(13))
}

function getNumberOfLines(title, widgetWidth, fontSize) {
    let isContainSpace = title.indexOf('\n')
    if (isContainSpace < 0) {
        isContainSpace = title.indexOf('\r')
    }
    if (isContainSpace > -1) {
        return 2
    }
    let nameLength = getByteCount(title)
    let totalWidth = nameLength / 2.0 * fontSize
    if (totalWidth <= widgetWidth) {
        return 1
    } else {
        return 2
    }
}

function getWidgetHeight(item, widgetWidth) {
    const numberOfLines = getNoteNumberOfLines(item, widgetWidth)
    const data = item
    let { img, img_w = 1, img_h = 1, goods_id } = data
    let ratio = (img_h > 0 ? img_h : 1) / (img_w > 0 ? img_w : 1)
    ratio = Math.min(ratio, 4.0 / 3.0)
    ratio = Math.max(ratio, 3.0 / 4.0)
    let cardHeight = widgetWidth * ratio + px2dpSmall(9)
    cardHeight += px2dpSmall(8) // 图片和标题的间隔
    
    // 增加商品条高度
    if (goods_id) {
        cardHeight += px2dpSmall(36) // 商品条高度 + margin
        cardHeight += px2dpSmall(4) // 商品条与标题的间隔
    } else {
        cardHeight += px2dpSmall(6)
    }

    if (numberOfLines == 1) {
        cardHeight += px2dpSmall(18)
    }
    if (numberOfLines == 2) {
        cardHeight += px2dpSmall(18) * 2
    }
    cardHeight += (px2dpSmall(8) + px2dpSmall(18))
    return cardHeight
}

class SHNoteCommonVertStyle4Widget extends Component {

    constructor(props) {
        super(props)
        this.state = {
            cardInfo: props.dataSource || {}
        }
        this.cardWidth = props.cardWidth || vCardWidth
        this.praiseLock = false;
    }

    peloadingSvg = (url) => {//预加载图片资源
        if (this.praiseHiddenRef) {
            import('svgaplayerweb').then((SVGA) => {
                const player = new SVGA.Player(this.praiseHiddenRef);
                const parser = new SVGA.Parser(this.praiseHiddenRef); // 如果你需要支持 IE6+，那么必须把同样的选择器传给 Parser。
                parser.load(url, (videoItem) => {
                    player.loops = 1;
                    player.setVideoItem(videoItem);
                    player.startAnimation();
                    player.onFinished(() => {
                        player.stopAnimation(true);
                        if (url.includes('/8a40e7c94f8d375a920c52b5f2ab4207')) {
                            this.peloadingSvg(cancel_praised_animated)
                        }
                    });
                })
            });
        }
    }

    showPraiseSvga = (svgaUrl, dataSource, type) => {
        if (this.praiseRef) {
            import('svgaplayerweb').then((SVGA) => {
                const player = new SVGA.Player(this.praiseRef);
                const parser = new SVGA.Parser(this.praiseRef); // 如果你需要支持 IE6+，那么必须把同样的选择器传给 Parser。
                this.praiseRef.style.display = "flex";
                this.praiseImgRef.style.display = "none"; 
                parser.load(svgaUrl, (videoItem) => {
                    player.loops = 1;
                    player.setVideoItem(videoItem);
                    player.startAnimation();
                    player.onFinished(() => {
                        this.praiseRef.style.display = "none";
                        this.praiseImgRef.style.display = "flex"; 
                        player.stopAnimation(true);
                        this.praiseLock = false;
                    });
                    player.onPercentage((percentage) => {
                        if ((type === 'add' && percentage >= 0.45) || (type === 'del' && percentage >= 0.8)) {
                            this.setState({
                                cardInfo: dataSource
                            })
                        }
                    })
                })
            });
        }
    }

    _isShowTip = (is_video, show_type, type, format_duration) => {
        let show = false
        let icon = ''
        let text = ''
        if (is_video == 1) {
            // Style4: 视频图标显示在右上角，这里不需要底部提示
            show = false 
            // 如果需要保留文章攻略等类型的提示，可以保留下面的逻辑
            // 但视频类型的提示在Style4中被移除了（或者是移动了位置）
        } else if (show_type == 'single28') {
            show = true
            icon = article_icon
            text = '文章'
        } else if (type == 1) {
            show = true
            icon = article_icon
            text = '攻略'
        }
        return { show, icon, text }
    }

    componentDidMount() {
        this.peloadingSvg(praised_animated)
    }

    componentWillReceiveProps(nextProps) {
        if (JSON.stringify(this.props.dataSource) !== JSON.stringify(nextProps.dataSource)) {
            this.setState({
                cardInfo: nextProps.dataSource
            });
        }
    }

    _onLogin = () => {
        window.Jockey.send("action", {
          url: "shihuo://www.shihuo.cn?route=login",
        });
    }

    _onPress = (extraBiz = {}) => {
        this.props.onPress && this.props.onPress(extraBiz)
    }

    _onZanPress = async () => {
        const isLogin = this.props.isLogin;
        if (!isLogin) {
            this._onLogin();
            return
        }

        if (this.praiseLock) {
            return;
        }
        this.praiseLock = true;

        const { itemIndex = 0 } = this.props
        let dataSource = this.props.dataSource
        let { note_id = '', channel_type = '4', isPraise = false, praiseNum = 0, praise } = dataSource
        praiseNum = parseInt(praiseNum || praise) || 0;
        dataSource.isPraise = !isPraise
        praiseNum += (!isPraise ? 1 : -1)
        dataSource.praiseNum = praiseNum || 0

        utils.uploadTrack(this.props, {}, {
            ptiId: `goodsSet:like:`,
            bizExtra: {
                region: '其他',
                article_id: note_id,
                is_cancel: dataSource.isPraise ? 0 : 1,
                filter_value: {}
            }
        });
        
        if (dataSource.isPraise) {
            this.showPraiseSvga(praised_animated, dataSource, 'add')
        } else {
            this.showPraiseSvga(cancel_praised_animated, dataSource, 'del')
        }

        requestNotePraised(note_id, channel_type, !isPraise).then(value => {
            this._onSendPraiseMessage({
                type: dataSource.isPraise ? 'add' : 'del',
                count: praiseNum,
                token: `webCallEvent_NoteId_${note_id}`,
                id: note_id,
            })
        }).catch(err => { })
    }

    // 发送点赞消息（用于原生二级页面更新笔记详情的点赞状态）
    _onSendPraiseMessage = ({ type, count, token, id } = {}) => {
        window.Jockey.send('webCallEvent', {
            eventName: 'kFemaleUpdatePraiseCountChange',
            body: {
                type,
                count,
                token,
                id,
            },
        });
    }

    render() {
        let {
            img = '',
            cover_img = '',
            profilePic = '',
            nickname = '',
            praiseNum = '',
            img_w = 1,
            img_h = 1,
            isPraise = false,
            is_video = 0,
            video = {},
            name = '',
            format_duration = '00:00',
            show_type = '',
            type = 0,
            level = 0,
            price,
            price_desc = '',
            goods_id = '',
            goodsId = '',
            sales_info_text = '',
            sales_info_num = ''
        } = this.props.dataSource
        const { h5_exposure_object = {} } = this.props;
        
        const numberOfLines = getNoteNumberOfLines(this.props.dataSource, this.cardWidth)

        let ratio = (img_h > 0 ? img_h : 1) / (img_w > 0 ? img_w : 1)
        ratio = Math.min(ratio, 4.0 / 3.0)
        ratio = Math.max(ratio, 3.0 / 4.0)

        img = img.split('#keepOn').join('')
        if (is_video == 1) {
            let videoImg = video.img || ''
            if (videoImg.length > 0) {
                img = videoImg.split('#keepOn').join('')
            }
        }
        const tipObj = this._isShowTip(is_video, show_type, type, format_duration)
        // 传入 displayProduct 以便正确计算高度
        const containerHeight = getWidgetHeight(this.props.dataSource, this.cardWidth)
        
        // 商品条数据
        const hasProduct = Boolean(goods_id || goodsId);

        return (
            <div
                ref={ele => {
                    if (ele) {
                        this.props.exp && this.props.exp(ele);
                    }
                }}
                data-dot={JSON.stringify(h5_exposure_object)}
                className='goods-card'
                style={{
                    ...styles.container,
                    width: this.cardWidth,
                    height: containerHeight - px2dpSmall(9),
                }}
            >
                <div
                    className='note-content'
                    style={styles.content}
                    onClick={() => this._onPress()}
                >
                    <div
                        className='node-img-wrap'
                        style={{
                            ...styles.img,
                            height: this.cardWidth * ratio,
                            position: 'relative',
                        }}
                    >
                        <LazyLoadImage
                            key={this.props.key}
                            className='node-img'
                            src={utils.shortImageSize(cover_img)}
                            effect="opacity"
                            wrapperProps={{
                                style: {
                                    transitionDuration: '700ms',
                                },
                            }}
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                borderRadius: styles.img.borderRadius,
                                display: 'block',
                            }}
                        />
                        {/* 视频图标 - 右上角 */}
                        {is_video == 1 && (
                             <div style={styles.videoIconContainer}>
                                <img src={play_icon} style={styles.playIcon} alt="play" />
                             </div>
                        )}

                        {tipObj.show ? (
                            <div
                                className='node-video'
                                style={{
                                    ...styles.video,
                                    backgroundImage: `url(${bottom_bg_icon})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat',
                                }}
                            >
                                <div
                                    className='node-video-text'
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        height: px2dpSmall(16),
                                        marginBottom: px2dpSmall(4),
                                        width: '100%',
                                        boxSizing: 'border-box',
                                    }}
                                >
                                    <img
                                        className='node-video-icon'
                                        src={tipObj.icon}
                                        alt="tip-icon"
                                        style={
                                            is_video == 1
                                                ? styles.video_icon
                                                : styles.article_icon
                                        }
                                    />
                                    <span
                                        style={styles.video_text}
                                        className='node-video-tip'
                                    >
                                        {tipObj.text}
                                    </span>
                                </div>
                            </div>
                        ) : null}
                    </div>

                    {/* 商品条 */}
                    {hasProduct && (
                        <div
                            style={styles.productBar}
                            onClick={(e) => {
                                e.stopPropagation();
                                this._onPress({ region: '商卡' })
                            }}
                        >
                            <img src={utils.shortImageSize(img)} style={styles.productImg} alt="product" />
                            <div style={styles.productInfo}>
                                <div style={styles.priceRow}>
                                    {
                                        price ? (
                                            <Fragment>
                                                <span style={styles.currency}>¥</span>
                                                <span style={styles.price}>{price}</span>
                                            </Fragment>
                                        ) : <span style={styles.noPrice}>{price_desc || '暂时缺货'}</span>
                                    }
                                    {(sales_info_text && sales_info_text != '0') && <span style={styles.sales}>{sales_info_text}{sales_info_num}</span>}
                                </div>
                            </div>
                            <img src="https://static.shihuocdn.cn/admin/files/20260303/f2884aff54c397a0718bf636675bfbc8.png" alt="" style={styles.arrowIcon} />
                        </div>
                    )}

                    {name.length > 0 ? (
                        <p
                            className='node-title'
                            style={{
                                ...styles.title,
                                height: numberOfLines * px2dpSmall(18),
                                lineHeight: '18px',
                                overflow: 'hidden',
                                marginTop: hasProduct ? px2dpSmall(4) : px2dpSmall(6),
                            }}
                        >
                            {name}
                        </p>
                    ) : null}

                    <div
                        className='node-bottom'
                        style={styles.bottom}
                    >
                        <div
                            className='node-avatar-wrap'
                            style={styles.avatar}
                        >
                            <img
                                className='node-avatar'
                                src={utils.shortImageSize(profilePic)}
                                alt="avatar"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    borderRadius: styles.avatar.borderRadius,
                                    objectFit: 'cover',
                                    display: 'block',
                                }}
                            />
                            {level != 0 ? (
                                <img
                                    className='node-avatar-level'
                                    src={utils.shortImageSize(
                                        getUserLevelImg(level)
                                    )}
                                    alt="level"
                                    style={styles.avatar_level}
                                />
                            ) : null}
                        </div>

                        <span
                            className='node-author-name'
                            style={{
                                ...styles.author_name,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            }}
                            title={nickname}
                        >
                            {nickname}
                        </span>

                        <div
                            className="praise-view"
                            style={styles.zanContainer}
                            onClick={(e) => {
                                e.stopPropagation();
                                this._onZanPress();
                            }}
                        >
                            <div className='praise-icon-content' style={styles.zan}>
                                <img
                                    className={"praise-icon"}
                                    style={styles.zan}
                                    ref={ref => this.praiseImgRef = ref}
                                    src={this.state.cardInfo.isPraise ? praised_icon : un_praised_icon}
                                    alt=""
                                />
                                <div
                                    className="praise-icon-svga"
                                    style={{
                                        ...styles.zanPreload,
                                        position: 'absolute',
                                        left: 0,
                                        top: 0,
                                        zIndex: 1
                                    }}
                                >
                                    <div style={{ width: 0, height: 0, overflow: 'hidden', position: 'absolute', left: 0, top: 0}} ref={ref => this.praiseHiddenRef = ref} />
                                    <div style={{ width: px2dpSmall(20), height: px2dpSmall(20), alignItems: 'center', justifyContent: 'center'}} ref={ref => this.praiseRef = ref} />
                                </div>
                            </div>
                            {
                                this.state.cardInfo.praiseNum > 0 && <div className="praise-num" style={styles.zanNum}>{this.state.cardInfo.praiseNum}</div>
                            }
                        </div>
                    </div>
                    <div style={{ width: '100%', height: px2dpSmall(4) }} />
                </div>
            </div>
        )
    }
}

SHNoteCommonVertStyle4Widget.propTypes = {
    dataSource: PropTypes.object,
    itemIndex: PropTypes.number,
    onZanPress: PropTypes.func
}

SHNoteCommonVertStyle4Widget.defaultProps = {
    dataSource: {},
    itemIndex: 0,
    onZanPress: () => { }
}

const styles = {
    container: {
        marginBottom: px2dpSmall(9),
        overflow: 'hidden',
    },
    content: {
        width: '100%',
        borderRadius: 6,
        backgroundColor: '#ffffff',
        overflow: 'hidden',
        flex: 1
    },
    img: {
        width: '100%',
        height: px2dpSmall(233),
        overflow: 'hidden',
        borderRadius: 6,
    },
    video: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
        // alignItems: 'center',
        // alignContent: 'flex-end',
        width: '100%',
        height: px2dpSmall(28),
    },
    videoIconContainer: {
        position: 'absolute',
        top: px2dpSmall(8),
        right: px2dpSmall(8),
        width: px2dpSmall(18),
        height: px2dpSmall(18),
        zIndex: 10,
    },
    playIcon: {
        width: '100%',
        height: '100%',
    },
    video_icon: {
        marginLeft: px2dpSmall(10),
        width: px2dpSmall(9),
        height: px2dpSmall(12),
        marginTop: px2dpSmall(1),
    },
    article_icon: {
        marginLeft: px2dpSmall(10),
        width: px2dpSmall(10),
        height: px2dpSmall(11),
        marginTop: px2dpSmall(2),
    },
    video_text: {
        fontFamily: 'PingFangSC-Regular',
        fontSize: px2dpSmall(11),
        color: 'white',
        marginLeft: px2dpSmall(3),
    },
    productBar: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        height: px2dpSmall(30),
        marginTop: px2dpSmall(6),
        backgroundColor: '#F8F8F8',
        borderRadius: px2dpSmall(4),
        paddingRight: px2dpSmall(9),
        paddingLeft: px2dpSmall(2),
    },
    productImg: {
        width: px2dpSmall(26),
        height: px2dpSmall(26),
        borderRadius: px2dpSmall(4),
        objectFit: 'cover',
        marginRight: px2dpSmall(4),
        backgroundColor: '#FFF',
    },
    productInfo: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    priceRow: {
        paddingTop: px2dpSmall(2),
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    currency: {
        fontFamily: 'SHIHUOSans-Medium',
        fontSize: px2dpSmall(11),
        color: '#333333',
        fontWeight: '500',
        marginTop: px2dpSmall(2)
    },
    price: {
        fontFamily: 'SHIHUOSans-Medium',
        fontSize: px2dpSmall(13),
        color: '#333333',
        fontWeight: '500',
    },
    noPrice: {
        fontFamily: 'PingFangSC-Regular',
        fontSize: px2dpSmall(10),
        color: '#999999',
        fontWeight: '400',
    },
    sales: {
        fontFamily: 'PingFangSC-Regular',
        fontSize: px2dpSmall(10),
        color: '#666666',
        marginLeft: px2dpSmall(4),
    },
    arrowIcon: {
        width: px2dpSmall(10),
    },
    title: {
        fontFamily: 'PingFangSC-Medium',
        fontWeight: '500',
        fontSize: px2dpSmall(14),
        color: '#333333',
        marginTop: px2dpSmall(4),
        marginLeft: px2dpSmall(4),
        marginRight: px2dpSmall(4),
        textAlign: 'left'
    },
    bottom: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        height: px2dpSmall(18),
        marginTop: px2dpSmall(8),
        marginLeft: px2dpSmall(4),
        marginRight: px2dpSmall(4)
    },
    avatar: {
        width: px2dpSmall(18),
        height: px2dpSmall(18),
        borderRadius: px2dpSmall(18) / 2.0,
        position: 'relative',
    },
    avatar_level: {
        width: px2dpSmall(9),
        height: px2dpSmall(8),
        position: 'absolute',
        right: -px2dpSmall(2),
        bottom: 0
    },
    author_name: {
        fontFamily: 'PingFangSC-Regular',
        fontSize: px2dpSmall(11),
        color: '#666666',
        marginLeft: px2dpSmall(5),
        flex: 1
    },
    zanContainer: {
        marginTop: utils.isAndroid() ? px2dpSmall(1) : px2dpSmall(0),
        marginLeft: px2dpSmall(0),
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    zan: {
        position: 'relative',
        width: px2dpSmall(20),
        height: px2dpSmall(20),
    },
    zanPreload: {
        position: 'absolute',
        width: px2dpSmall(20),
        height: px2dpSmall(20),
    },
    zanNum: {
        marginLeft: px2dpSmall(0),
        fontFamily: 'PingFangSC-Regular',
        fontSize: px2dpSmall(12),
        color: '#666666',
        height: px2dpSmall(16),
        marginBottom: utils.isAndroid() ? px2dpSmall(-2) : px2dpSmall(2),
    }
}

export default {
    widget: SHNoteCommonVertStyle4Widget,
    getWidgetHeight,
    showStyleList: false,
}



// WEBPACK FOOTER //
// ./components/pipeline-recommend/lib/SHCard/widgets/SHNoteCommonVertStyle4Widget.js